import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';

import { ISuperscriptConfiguration, ISuperscriptProps, ISuperscriptState } from './models/index.js';
import { SUPERSCRIPT_CATEGORY_KEY, SUPERSCRIPT_COMPONENT_KEY } from './Superscript.meta.js';

export class Superscript extends ComponentBase<ISuperscriptProps, ISuperscriptState, ISuperscriptConfiguration> {
	categoryKey = SUPERSCRIPT_CATEGORY_KEY;
	componentKey = SUPERSCRIPT_COMPONENT_KEY;

	constructor(props: ISuperscriptProps) {
		super(props);
	}
	render() {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const { className, children, configuration, ...props } = this.props;

		if (!children) {
			return null;
		}

		return (
			<sup className={className} {...props}>
				{children}
			</sup>
		);
	}
}

export default InjectedStyledComponent(observer(Superscript), SUPERSCRIPT_CATEGORY_KEY, SUPERSCRIPT_COMPONENT_KEY);
